import { Divider, Stack } from '@mui/material'
import AdminProfile from './AdminProfile'
import Header from './Header'
import PlanAndPayment from './PlanAndPayment'
import ShopInfo from './ShopInfo'

export default function AccountSettings() {
    return (
        <Stack
            direction="column"
            spacing={2}
        >
            <Header handleOnHeaderButtonClick={()=>{}} />
            <Divider />
            <AdminProfile />
            <ShopInfo />
            <PlanAndPayment />
        </Stack>
    )
}
